module.exports = __webpack_public_path__ + "img/true360-report-spread.fdb8ae39.png";